import * as R from 'ramda'

//noinspection JSUnusedGlobalSymbols
export default {

    counts: state => state.counts,

    all: state => {
        return R.compose(

            // Nach Namen sortieren
            R.sortBy(R.prop('name')),

            // Models in Array lesen
            R.values,

            // Entities einlesen
            R.prop('entities')

        )(state)
    },

    allByBelongsToZmuek: (state, getters) => {
        return getters['allByCompanyId'](2)
    },

    allByCompanyId: (state, getters) => companyId => {
        return R.filter(address => R.any(link => link.company === companyId, address.companies || []), getters['all'])
    },

    allByCompanyIdAndIsBillingAddress: (state, getters) => id => {
        return R.compose(

            // Nach Lieferadresse filtern
            // >
            R.filter(R.propEq('isBillingAddress', true)),

            // Adressen laden
            // > [ { id: 1, companies: [{ company: 2 }] }, { id: 2, companies: [{ company: 3 }] } ]
            // < [ { id: 2, companies: [{ company: 2 }] } ]
            getters['allByCompanyId']

        )(id)
    },

    allByCompanyIdAndIsCorrespondenceAddress: (state, getters) => id => {
        return R.compose(

            // Nach Lieferadresse filtern
            R.filter(R.propEq('isCorrespondenceAddress', true)),

            // Adressen laden
            getters['allByCompanyId']

        )(id)
    },

    allByCompanyIdAndIsShippingAddress: (state, getters) => id => {
        return R.compose(

            // Nach Lieferadresse filtern
            R.filter(R.propEq('isShippingAddress', true)),

            // Adressen laden
            getters['allByCompanyId']

        )(id)
    },

    byId: state => id => {
        return state.entities[id]
    },

}


